// extracted by mini-css-extract-plugin
module.exports = {"sizesm":"illustration_sizesm__jDuvy","sizemd":"illustration_sizemd__IXL1y","sizelg":"illustration_sizelg__lLFX0"};